<template>
  <div class="menus">
    <el-card shadow="never">
      <div class="header-flex">
        <h1>菜单列表</h1>
        <div class="flex-right">
          <el-button type="primary" size="small" @click="addMenu"
            >添加菜单</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :max-height="scrollHeight"
      >
        <el-table-column fixed prop="id" label="ID" sortable></el-table-column>
        <el-table-column prop="sort" label="排序" sortable></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="page_url" label="路径"></el-table-column>
        <el-table-column prop="unselected_icon_pic_path" label="选择前图标">
          <template slot-scope="scope">
            <el-image
              class="itemImg"
              :src="imgUrl + scope.row.unselected_icon_pic_path"
              fit="fill"
              :preview-src-list="previewList"
              @click="previewImg(imgUrl + scope.row.unselected_icon_pic_path)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="selected_icon_pic_path" label="选中后图标">
          <template slot-scope="scope">
            <el-image
              class="itemImg"
              :src="imgUrl + scope.row.selected_icon_pic_path"
              fit="fill"
              :preview-src-list="previewList"
              @click="previewImg(imgUrl + scope.row.selected_icon_pic_path)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="success">已通过</el-tag>
            <el-tag v-else type="info">未通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              @click="modifyRow(scope.row, scope.$index)"
              type="primary"
              size="small"
              >修改</el-button
            >
            <el-button @click="deleteRow(scope.row)" type="danger" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-card>

    <!-- 修改对话框 -->
    <el-dialog title="修改内容" :visible.sync="dialogVisible" width="50%">
      <el-form
        :model="form"
        ref="form"
        :rules="rules"
        :label-width="`${100}px`"
      >
        <el-form-item label="菜单排序" prop="sort">
          <el-input
            v-model.number="form.sort"
            placeholder="请输入排序序号 (排序越小越靠前)"
            oninput="value=value.replace(/[^\d.]/g,'')"
          />
        </el-form-item>
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model.trim="form.name" placeholder="请输入菜单名称" />
        </el-form-item>
        <el-form-item label="小程序路径" prop="page_url">
          <el-input
            v-model.trim="form.page_url"
            placeholder="请输入小程序页面路径"
          />
        </el-form-item>
        <el-form-item label="选择前图标" prop="unselected_icon_pic_path">
          <el-upload
            class="avatar-uploader"
            :action="uploadAction"
            :accept="uploadAccept"
            :data="uploadToken"
            :show-file-list="false"
            :on-success="
              (res, file, fileList) =>
                handleAvatarSuccess(res, file, fileList, 1)
            "
            :on-error="handleAvatarError"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="form.unselected_icon_pic_path"
              :src="imgUrl + form.unselected_icon_pic_path"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="选择后图标" prop="selected_icon_pic_path">
          <el-upload
            class="avatar-uploader"
            :action="uploadAction"
            :data="uploadToken"
            :show-file-list="false"
            :accept="uploadAccept"
            :on-success="
              (res, file, fileList) =>
                handleAvatarSuccess(res, file, fileList, 2)
            "
            :on-error="handleAvatarError"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="form.selected_icon_pic_path"
              :src="imgUrl + form.selected_icon_pic_path"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="状态" v-if="confirmType == 2">
          <el-select v-model="form.status" placeholder="请选择状态">
            <el-option label="通过" :value="1"></el-option>
            <el-option label="拒绝" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmModify('form')"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { menuList, saveMenu, delMenu } from "@/api/setting";
export default {
  name: "menus",
  data() {
    return {
      tableData: [], // 列表数据
      pageSize: 10, // 单页数量
      total: 0, // 数据总数
      currentPage: 1, // 当前页面
      scrollHeight: 100, // 滚动条高度
      confirmType: 1, // 表单提交类型 1:添加  2:编辑
      dialogVisible: false, // 添加/编辑对话框
      previewList: [], // 预览图片
      form: {
        // 表单
        id: 0,
        sort: "",
        name: "",
        page_url: "",
        unselected_icon_pic_path: "",
        selected_icon_pic_path: "",
        status: "",
      },
      rules: {
        // 表单验证规则
        name: [
          { required: true, message: "请输入菜单名称", trigger: "blur" },
          { min: 1, max: 5, message: "长度在 1 到 5 个字符", trigger: "blur" },
        ],
        sort: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        page_url: [
          {
            required: true,
            message: "请输入小程序页面地址",
            trigger: "change",
          },
        ],
        selected_icon_pic_path: [
          {
            required: true,
            message: "请上传选择后图",
            trigger: "change",
          },
        ],
        unselected_icon_pic_path: [
          {
            required: true,
            message: "请上传选择前图",
            trigger: "change",
          },
        ],
      },
      uploadToken: {
        // 图片上传附带的token参数
        token: this.$store.getters.userinfo.login_token,
      },
    };
  },
  created() {
    this.$store.dispatch("fullscreenLoading", true);
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollHeight = document.body.clientHeight - 290;
    });
    this.getData();
  },
  methods: {
    /**
     * 获取数据
     */
    getData() {
      menuList({
        page: this.currentPage,
        limit: this.pageSize,
      }).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.$store.dispatch("fullscreenLoading", false);
      });
    },
    /**
     * 改变单页数量
     * @param {number} val - 单页数量值
     */
    handleSizeChange(val) {
      this.$store.dispatch("fullscreenLoading", true);
      this.pageSize = val;
      this.getData();
    },
    /**
     * 改变当前页面
     * @param {number} val - 当前页面的值
     */
    handleCurrentChange(val) {
      this.$store.dispatch("fullscreenLoading", true);
      this.currentPage = val;
      this.getData();
    },
    /**
     * 修改操作
     * @param {object} row - 列表项
     * @param {number} index - 下标
     */
    modifyRow(row) {
      this.$refs["form"] && this.$refs["form"].resetFields();
      this.confirmType = 2;
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    /**
     * 添加菜单
     */
    addMenu() {
      this.$refs["form"] && this.$refs["form"].resetFields();
      if (this.confirmType !== 1) {
        this.confirmType = 1;
        this.form = {
          id: 0,
          sort: "",
          name: "",
          page_url: "",
          unselected_icon_pic_path: "",
          selected_icon_pic_path: "",
          status: "",
        };
      }
      this.dialogVisible = true;
    },
    /**
     * 删除操作
     * @param {object} row - 列表项
     */
    deleteRow(row) {
      this.$confirm(`是否要删除菜${row.name}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delMenu({
          id: row.id,
        }).then(() => {
          this.$message.success("删除成功");
          this.getData();
        });
      });
    },
    /**
     * 确认修改
     * @param {string} formName - ref绑定的表单名
     */
    confirmModify(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          saveMenu(this.form).then(() => {
            this.$store.dispatch("fullscreenLoading", true);
            this.dialogVisible = false;
            const index = this.tableData.findIndex(
              (e) => e.id === this.form.id
            );
            this.tableData[index] = this.form;
            this.$message.success("提交成功!");
            this.getData();
            this.form = {
              id: 0,
              sort: "",
              name: "",
              page_url: "",
              unselected_icon_pic_path: "",
              selected_icon_pic_path: "",
              status: "",
            };
          });
        } else {
          this.$notify.error({
            title: "错误",
            message: "提交的参数有误!",
          });
          return false;
        }
      });
    },
    /**
     * 图片上传成功
     * @param {object} res - http请求成功返回的响应内容
     * @param {object} file - 当前本地文件
     * @param {array} fileList - 文件列表
     * @param {number} type - 类型 1:选择前  2:选择后
     */
    handleAvatarSuccess(res, file, fileList, type) {
      this.$message.closeAll();
      if (res.code == 200) {
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
        const { path, filename } = res.data.files[0];
        if (type == 1) {
          this.form.unselected_icon_pic_path = path + filename;
        } else {
          this.form.selected_icon_pic_path = path + filename;
        }
      } else {
        this.$message({
          showClose: true,
          message: res.data,
          type: "error",
        });
      }
    },
    /**
     * 图片上传失败
     * @param {object} res - http请求成功返回的响应内容
     */
    handleAvatarError(res) {
      this.$message.closeAll();
      this.$message({
        showClose: true,
        message: "上传失败" + JSON.stringify(res),
        type: "error",
      });
    },
    /**
     * 图片上传之前
     * @param {object} - 当前上传的本地文件
     */
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }
      this.$message({
        showClose: true,
        duration: 0,
        message: "正在上传，请稍后...",
      });
      return isLt2M;
    },
    /**
     * 预览图片
     * @param {string} url - 图片地址
     */
    previewImg(url) {
      this.previewList = [url];
    },
  },
};
</script>

<style scoped src="./style/index.css"></style>
